const fr = {
    estateTeaser: {
        new: 'Nouveau',
    },
    estateNavigation: {
        previous: 'Précédent',
        overview: 'Aperçu',
        next: 'Suivant',
    },
    estateSearch: {
        loading: 'Les propriétés sont en cours de chargement ...',
        search: 'Rechercher',
        emptyFilter: 'Filtre vide',
        noResults: 'Désolé, nous n\'avons trouvé aucun résultat pour votre recherche.',
        noResultsCTA: 'Pas trouvé ce que vous cherchiez?',
        noResultsCTADescription: 'Faites-nous savoir quels sont vos critères de recherche en remplissant le formulaire ci-dessous. Vous serez automatiquement informé des nouvelles propriétés qui répondent à vos critères.',
        noResultsCTAButton: 'Enregistrer',
        cheapestFirst: 'Prix le moins cher en premier',
        mostExpensiveFirst: 'Prix le plus cher en premier',
        oldestFirst: 'Le plus ancien en premier',
        newestFirst: 'Le plus récent d\'abord',
        result: 'résultat',
        results: 'résultats',
        showMap: 'montrer la carte',
        hideMap: 'cacher la carte',
        found: 'trouvé',
        sortBy: 'Trier sur',
        selected: 'choisi',
    },
    estimateForm: {
        fields: {
            firstName: 'Prénom',
            lastName: 'Nom',
            purpose: 'Type de Transaction',
            purposeOptions: {
                forSale: 'A vendre',
                forRent: 'A louer',
            },
            category: 'Type de bien',
            categoryOptions: {
                house: 'Maison',
                appartment: 'Appartement',
                ground: 'Grond',
                office: 'Bureau',
                commercial: 'Commerce',
                industrial: 'Entrepôt',
                parkingOrGarage: 'Parking ou garage',
            },
            mobile: 'Numéro de téléphone',
            email: 'Adresse e-mail',
            street: 'Rue',
            number: 'Numéro',
            box: 'Bus',
            postalCode: 'Code postal',
            city: 'Commune',
        },
        validation: {
            firstName: 'Prénom',
            lastName: 'Nom',
            purpose: 'type de transaction',
            category: 'type de bien',
            mobile: 'Numéro de téléphone',
            email: 'Adresse e-mail',
            street: 'Rue',
            number: 'Numéro',
            box: 'bus',
            postalCode: 'Code Postal',
            city: 'Commune',
        },
        submit: 'Envoyer',
    },
    estateSearchForm: {
        title: 'Que recherchez-vous',
        contactTitle: 'Détails du contact',
        fields: {
            purpose: 'Transaction',
            minPrice: 'Prix minimum',
            maxPrice: 'Prix maximum',
            locations: 'Communes',
            minBedrooms: 'Nombre minimum de chambres',
            subCategories: 'Type',
            firstName: 'Prénom',
            lastName: 'Nom',
            email: 'Adresse e-mail',
            mobile: 'Numéro de téléphone',
        },
        validation: {
            purpose: 'transaction',
            firstName: 'prénom',
            lastName: 'nom',
            email: 'adresse e-mail',
            mobile: 'numéro de téléphone',
            subCategories: 'type',
            minPrice: 'prix minimum',
            maxPrice: 'prix maximum',
            locations: 'communes',
            minBedrooms: 'nombre minimum de chambres',
        },
        submit: 'Tenez-moi informé',
    },
};

export { fr };
